// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"859":"f1e64d0da095b233","987":"d400477c78ee509f"}[chunkId] + ".js";
};